var map = {
	"./algeria.png": 3561,
	"./australia.png": 7439,
	"./austria.png": 201,
	"./belgium.png": 2955,
	"./canada.png": 1967,
	"./china.png": 3019,
	"./croatia.png": 2827,
	"./czech-republic.png": 7911,
	"./denmark.png": 7107,
	"./estonia.png": 4958,
	"./european-union.png": 1475,
	"./finland.png": 4740,
	"./france.png": 1978,
	"./germany.png": 975,
	"./greece.png": 2709,
	"./hong kong.png": 5912,
	"./hong-kong.png": 1053,
	"./hungary.png": 8660,
	"./ireland.png": 3977,
	"./italy.png": 4424,
	"./japan.png": 5897,
	"./korea.png": 3391,
	"./latvia.png": 5371,
	"./lithuania.png": 1217,
	"./luxembourg.png": 2233,
	"./macau.png": 1659,
	"./malaysia.png": 8619,
	"./mexico.png": 8745,
	"./morocco.png": 517,
	"./netherlands.png": 5959,
	"./new zealand.png": 7967,
	"./norway.png": 343,
	"./philippines.png": 5962,
	"./poland.png": 371,
	"./portugal.png": 3333,
	"./romania.png": 8869,
	"./russia.png": 8396,
	"./singapore.png": 5464,
	"./slovakia.png": 3910,
	"./south-korea.png": 9430,
	"./spain.png": 2660,
	"./sweden.png": 4556,
	"./switzerland.png": 3492,
	"./taiwan.png": 2514,
	"./thailand.png": 8614,
	"./tunisia.png": 1735,
	"./turkey.png": 4884,
	"./united kingdom.png": 8120,
	"./usa.png": 8432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4931;